import {productService} from '@/assets/js/http'

/**
 * 活动详情
 * @param {int} id 活动id
 */
export function activityDetailAPI(id) {
    return productService({
        url:`api/activities/${id}`,
        method: 'get'
    })
}

export function activityDetailItemsAPI(id) {
    return productService({
        url:`api/activities/${id}/items`,
        method: 'get'
    })
}

/**
 * 提交报名
 * @param {object} data 报名数据
 */
export function activitySubmitAPI(data) {
    return productService({
        url:'api/activities/submit',
        method: 'post',
        data
    })
}


export function activityOrderListAPI() {
    return productService({
        url: 'api/users/activities',
        method: 'get'
    })
}

export function ActivityOrderDetailAPI(id) {
    return productService({
        url: `api/users/activities/${id}`,
        method: 'get'
    })
}

export function activityOrderCancelAPI(orderCode) {
    return productService({
        url: 'api/activities/cancel',
        method: 'post',
        data: {orderCode}
    })
}